module.exports = __webpack_public_path__ + "img/8.c06b31b6.png";